// TODO: enum을 그대로 뷰에도 쓰고 쿼리에도 쓰고 있어서 swagger를 최신화하면서 타입이 깨지는 이슈 발생
// 키밸류를 추가하면 뷰에도 변경사항이 생기는데 확인된 부분이 아니라 any처리
export const COURSE_SORT = {
  RECENT: {
    label: '최신순',
    value: 'RECENT',
  },
  POPULAR: {
    label: '인기순',
    value: 'POPULAR',
  },
} as const;
